import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { CookieService } from './cookie.service';

@Injectable({
  providedIn: 'root'
})
export class AccessibilityService {

  private keyEventSubject = new Subject<KeyboardEvent>();
  public keyboardAccessibilityOn = false;
  public colorBlindAccessibilityOn = false;
  public highContrastAccessibilityOn = false;
  public stressFreeAccessibilityOn = false;
  public keyEventObs: Observable<KeyboardEvent> = this.keyEventSubject.asObservable();
  private keyDown = false;

  public distributeKeyPress(keyValue: KeyboardEvent): void {

    if (this.keyDown) { return; }

    this.keyDown = true;
    this.keyEventSubject.next(keyValue);
  }

  public releaseKey(): void {
    this.keyDown = false;
  }

  public CheckRelevantCookieData(): void {

    if (!this.keyboardAccessibilityOn) {
      this.keyboardAccessibilityOn = this.cookieService.GetCookieValue('keyboardAccessibilityOn') === 'true';
    }
    if (!this.colorBlindAccessibilityOn) {
      this.colorBlindAccessibilityOn = this.cookieService.GetCookieValue('colorBlindAccessibilityOn') === 'true';
    }
    if (!this.highContrastAccessibilityOn) {
      this.highContrastAccessibilityOn = this.cookieService.GetCookieValue('highContrastAccessibilityOn') === 'true';
    }
    if (!this.stressFreeAccessibilityOn) {
      this.stressFreeAccessibilityOn = this.cookieService.GetCookieValue('stressFreeAccessibilityOn') === 'true';
    }
  }

  public SaveCurrentValues(): void {
    this.cookieService.SetCookieValue('keyboardAccessibilityOn', this.keyboardAccessibilityOn);
    this.cookieService.SetCookieValue('colorBlindAccessibilityOn', this.colorBlindAccessibilityOn);
    this.cookieService.SetCookieValue('highContrastAccessibilityOn', this.highContrastAccessibilityOn);
    this.cookieService.SetCookieValue('stressFreeAccessibilityOn', this.stressFreeAccessibilityOn);
  }

  constructor(private cookieService: CookieService) { }
}
